import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=6c65aa6e&"
import script from "./ReviewDetail.vue?vue&type=script&lang=js&"
export * from "./ReviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports